import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener, Inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges, ViewChild
} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";

require('./bringoz-donut-chart.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-donut-chart',
  templateUrl: './bringoz-donut-chart.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozDonutChartComponent implements OnChanges {
  @Input() segments: { value: number, color: string, name?: string }[];
  @Input() pieChartConfiguration: {
    width: number,
    height: number,
    allowTooltip?: boolean,
    isShowLegend?: boolean,
    radius?: any,
    isShowLabel?: boolean,
    namesPrefix?: string,
    fontSize?: number
  } = {width: 5, height: 5, allowTooltip: false, isShowLegend: false};
  @Input() innerTextConfiguration: { text: string, color: string };
  @Output() clickEvent = new EventEmitter<any>();

  public donutChartOptions: any;

  chartInstance: any;

  onChartInit(chart: any) {
    this.chartInstance = chart;
  }

  @HostListener('window:resize')
  onResize() {
    this.chartInstance?.resize();
  }

  constructor(@Inject(TranslateService) private translateService: TranslateService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.segments && this.segments.length) {
      this.initDonutChart();
    }
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    if (!!this.donutChartOptions?.series?.length) {
      const innerTextConfigurationSeries = this.donutChartOptions.series.find(s => s.id === 'innerText');
      if (!!innerTextConfigurationSeries) {
        innerTextConfigurationSeries.label.fontSize = this.pieChartConfiguration.fontSize || this.remToPx(1.5);
      }
    }
  }


  private initDonutChart() {
    const data = [];
    const colors = [];
    this.segments.forEach((s, index) => {
      let segmentData = {
        value: s.value,
        name: this.pieChartConfiguration.namesPrefix ? this.translateService.instant(`${this.pieChartConfiguration.namesPrefix}.${s.name}`) : s.name || index
      }
      colors.push(s.color);
      data.push(segmentData);
    });
    this.donutChartOptions = {
      series: [
        {
          name: 'Donut Chart',
          type: 'pie',
          radius: this.pieChartConfiguration.radius || ['70%', '90%'],
          avoidLabelOverlap: false,
          itemStyle: {
            normal: {
              borderRadius: 3,
              borderColor: '#fff',
              borderWidth: 1,
              color: function (params) {
                return colors[params.dataIndex];
              }
            }
          },
          label: {
            show: this.pieChartConfiguration.isShowLabel,
            position: 'inside',
            formatter: '{d}%'
          },
          emphasis: {
            label: {
              show: false,
            }
          },
          labelLine: {
            show: false
          },
          data: data
        },
      ]
    };

    if (this.pieChartConfiguration.allowTooltip) {
      this.donutChartOptions.tooltip = {trigger: 'item'}
    }

    if (this.pieChartConfiguration.isShowLegend) {
      this.donutChartOptions.legend = {
        top: '2%',
        left: 'center'
      }
    }

    if (!!this.innerTextConfiguration) {
      const innerTextConfiguration = {
        name: 'Inner Text',
        id: 'innerText',
        type: 'pie',
        radius: ['0%', '30%'],
        avoidLabelOverlap: false,
        label: {
          show: true,
          position: 'center',
          formatter: `${this.innerTextConfiguration.text}`,
          fontSize: this.pieChartConfiguration.fontSize || this.remToPx(1.25),
          fontWeight: 'bold',
          color: this.innerTextConfiguration.color,
          align: 'center',
          verticalAlign: 'middle'
        },
        labelLine: {
          show: false
        },
        data: [
          {value: 0, name: 'Inner text'}
        ],
        itemStyle: {
          color: 'transparent',
        },
      }
      this.donutChartOptions.series.push(innerTextConfiguration);
    }
  }

  // calculateFontSize() {
  //   let scaleFactor = (window.innerWidth / 134) + (130 / window.innerWidth) + 1;
  //   return Math.round(scaleFactor);
  // }


  remToPx(rem: number): number {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
  }

}
